import { TextFields } from '@mui/icons-material'
import { Box, Button, Grid, Stack, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT

export default function Phone() {
  const [mobileNumber, setMobileNumber] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [open, setOpen] = useState(false);
  const [studentId, setStudentId] = useState('');
  const navigate = useNavigate()
  const handleOpen = () => {
    setOpen(true);
  };


  

  const handleClose = () => {
    setOpen(false);
    setErrorMessage('');
    setMobileNumber('');
  };
  const handleMobileSubmit = async () => {

    if (!mobileNumber) {
      setErrorMessage('Please enter mobile number');
      return
    }
  
    // Validate mobile number format (10 digits)
    const mobileRegex = /^[0-9]{10}$/;
    if (!mobileRegex.test(mobileNumber)) {
      setErrorMessage('Please enter a valid 10-digit mobile number');
      return;
    }
    try {
      const response = await fetch(`${API_ENDPOINT}route/enquirybymobile` , {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ mobile: mobileNumber }),
      });

      if (response.ok) {
        // If the mobile number is found, navigate to quiz1 route
        const data = await response.json();
        console.log("Data from API:", data); // Log data to see its structure and contents
        if (data.length > 0) {
          const id = data[0].id; // Accessing id from the first element of the array
          console.log("Student ID:", id); // Log the student ID
          setStudentId(id); // Save student ID
          navigate('/quiz1', { state: { studentId: id } }); // Passing studentId as state
        } else {
          setErrorMessage('Student data not found in response');
        }
      } else {
        // If the mobile number is not found, display error message
        setErrorMessage('Student not found. Please contact admin');
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };
  useEffect(() => {
    const handleBeforeUnload = (event) => {
     const isPageRefreshed = (event || window.event).returnValue;
     if (isPageRefreshed === undefined) {
      navigate('/test');
     }
    };
    // Attach the event listener for beforeunload
    window.addEventListener('beforeunload', handleBeforeUnload);
    // Cleanup the event listener on component unmount
    return () => {
     window.removeEventListener('beforeunload', handleBeforeUnload);
    };
   }, [navigate]);
 
   console.log(studentId) 
  return (
    <>
     <img src='/line_shape_1 1 (1).png' style={{ width: '200px', position: 'absolute', top: 37, left: 17 }} />
    <img src='/dot_shape_2 1 (1).png' style={{ width: '200px', position: 'absolute', bottom: 7, right: 7 }} />
    <Box
        className="rectangle"
        sx={{
             left: 0,
          width: '100%',
        background: 'linear-gradient(180deg, rgb(255, 246.42, 240.12) 0%, rgba(255, 246.42, 240.12, 0) 100%)',
          height: '100%',
          position: 'absolute',
          top: 0,
         zIndex: -1,
    
        }}
      />
    <Box sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      border: 0.2,
      borderRadius:2,
      borderColor:'#7A7A7A',
      
     margin:'5px',
      p: 4,
      maxWidth: '440px',
      maxHeight: '80%',
      overflow: 'auto',
     
      
    }}>
    
      <Typography   sx={{ marginBottom:'20px', fontSize:'24px',fontWeight:400}}>Kindly fill the below detail to start your Evaluation test </Typography>
   
      <TextField
        type="text"
       label="Enter mobile number"
        value={mobileNumber}
        onChange={(e) => setMobileNumber(e.target.value)}
        style={{  width: '100%',marginTop:'10px'}}
      />
      <Stack  display='flex'  flexDirection='row' >
        <Stack sx={{width:'100%'}}>
      <Button
        variant='contained'
        style={{ background: '#019E6F', color: 'white', height: '35px', fontSize: '20px' ,marginTop:'20px' }}
        onClick={handleMobileSubmit}
      >
        Submit
      </Button>
      </Stack>
     
      </Stack>
      {errorMessage && <Typography sx={{ color: 'red', fontSize: '16px', marginTop: '10px' }}>{errorMessage}</Typography>}
     
    </Box>
    </>
  )
}
